import * as actionTypes from "action-types";

const initialState = {
  eventInfo: {},
  committeeSelectedForm: {
    selectedCommitteeList: {},
    formSelectedCommitteeList: [],
  },
  committeeOptions: {},
  meetingList: [],
  addCustomMeetings: false,
  customMeetings: [],
  meetings: {}
};

const myScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MY_SCHEDULE_VALUES:
      return {
        ...state,
        eventInfo: { ...action.values }
      };
    case actionTypes.MEETING_SUBMIT_SELECTED_COMMITTEES:
      return {
        ...state,
        committeeSelectedForm: {
          selectedCommitteeList: action.values.selectedCommitteeItem,
          formSelectedCommitteeList: action.values.formSelectedCommitteeList,
        },
      };
    case actionTypes.COMMITTEE_OPTIONS:
      return {
        ...state,
        committeeOptions: action.values
      };
    case actionTypes.MEETING_LIST:
      return {
        ...state,
        meetingList: action.values
      };
    case actionTypes.ADD_CUSTOM_MEETINGS:
      return {
        ...state,
        addCustomMeetings: action.values
      };
    case actionTypes.CUSTOM_MEETINGS:
      return {
        ...state,
        customMeetings: action.values
      };
    case actionTypes.MEETINGS:
      return {
        ...state,
        meetings: action.values
      };
    default:
      return state;
  }
};

export default myScheduleReducer;
